window.initContactMap = function () {
    let latLng = {
        lat: 52.08227,
        lng: 4.30902
    };

    let element = document.getElementById('contact-map');
    let options = {
        zoom: 10,
        center: latLng
    };

    let map = new google.maps.Map(element, options);
    let marker = new google.maps.Marker({
        position: latLng,
        map: map,
        title: 'Visa service Desk'
    });

    let infowindow = new google.maps.InfoWindow({
        content: '<div class="bg-white"><h4>Visa Service Desk</h4><p>Parkstraat 15-5e Etage, 2514 JD, Den Haag</p></div>'
    });

    infowindow.open(map, marker);

    marker.addListener('click', function () {
        infowindow.open(map, marker);
    });
};